var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C15 14.4477 15.4477 14 16 14C16.5523 14 17 14.4477 17 15V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V15Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5C15 19.2239 15.2239 19 15.5 19H16.5C16.7761 19 17 19.2239 17 19.5C17 19.7761 16.7761 20 16.5 20H15.5C15.2239 20 15 19.7761 15 19.5Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0342 10.5405C15.4656 9.81984 16.5344 9.81984 16.9658 10.5405L22.846 20.3617C23.2808 21.0879 22.7431 22 21.8802 22H10.1198C9.25685 22 8.71918 21.0879 9.154 20.3617L15.0342 10.5405ZM16.1078 11.0542L21.988 20.8754C22.0002 20.8957 22 20.9057 22 20.9094C21.9999 20.9165 21.9977 20.9295 21.9883 20.9453C21.9789 20.9613 21.9655 20.9747 21.95 20.9838C21.9369 20.9915 21.9161 21 21.8802 21H10.1198C10.0839 21 10.0631 20.9915 10.05 20.9838C10.0345 20.9747 10.0211 20.9613 10.0117 20.9453C10.0023 20.9295 10.0001 20.9165 10 20.9094C9.99995 20.9057 9.9998 20.8957 10.012 20.8754L15.8922 11.0542C15.9044 11.0338 15.917 11.0234 15.9308 11.016C15.9472 11.0071 15.9712 11 16 11C16.0288 11 16.0528 11.0071 16.0692 11.016C16.083 11.0234 16.0956 11.0338 16.1078 11.0542Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.80c911ce134115d89321aa23d6b96c67.svg";
export { ForwardRef as ReactComponent };